module.exports = __webpack_public_path__ + "static/media/3DPPA23.02a67e61.jpg";